import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-navy-card relative overflow-hidden" data-id="element-183" data-mp="1d0cp9qc68bfb">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-gradient-to-r from-transparent via-gold to-transparent opacity-50" data-id="element-184" data-mp="1rqbj5gwp10oz" />
      <div className="max-w-4xl mx-auto text-center" data-id="element-185" data-mp="1mtbcp4vxlvxc">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-186" data-mp="z2foehqopiuu">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-gold/10 text-gold mb-5" data-id="element-187" data-mp="u3unsh7isx5v"><span className="text-2xl" data-id="element-188" data-mp="183m62u52kzpo">🏆</span></div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-189" data-mp="13zy20lfncm96">The Most Complete Research Methods Teaching System for High School and Introductory College Courses Worldwide</h2>
          <h3 className="text-xl font-bold text-gold-gradient mb-3" data-id="element-190" data-mp="2ffwg53polyh9">Research Methods Teacher Ready™</h3>
          <p className="text-base md:text-lg text-gray-300 mb-10" data-id="element-191" data-mp="2bvz36b2jww7y">6 complete resources. One complete system. Everything ready to use starting today.</p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-192" data-mp="2gwwi8es9la58">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-3 bg-black p-6 rounded-2xl border border-navy-border" data-id="element-193" data-mp="2kxow5lc3037u">
            {['This is not a collection of random worksheets pulled from the internet.', 'This is not a theoretical research textbook you have to rewrite before it works in a real classroom.', 'This is not content designed for a different context that you have to completely adapt.'].map(item => <div key={item} className="flex items-start gap-3" data-id="element-194" data-mp="19h8a3960uoc0"><X className="text-red-500 shrink-0 mt-1" size={18} data-id="element-195" data-mp="19ggsj299er4q" /><p className="text-gray-400 text-sm" data-id="element-196" data-mp="1egbeqsi3asjg">{item}</p></div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-gold/10 p-6 rounded-2xl border border-gold/30 relative overflow-hidden" data-id="element-197" data-mp="2hqz4phdszbfu">
            <div className="absolute top-0 right-0 w-32 h-32 bg-gold/20 blur-3xl rounded-full" data-id="element-198" data-mp="2qjapamm8k4nw" />
            <div className="flex items-start gap-3 relative z-10" data-id="element-199" data-mp="2mi7fagqvd2ul">
              <Check className="text-gold shrink-0 mt-1" size={20} data-id="element-200" data-mp="2mk1y9pikykw1" />
              <p className="text-white font-medium text-base leading-relaxed" data-id="element-201" data-mp="1yt61edz9ozhx">This is a complete 6-in-1 professional teaching system: one complete lesson library plus five strategic resources that cover every gap, every challenging day and every assessment need — so you walk into every class completely prepared, confident and ready.</p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}